import { ChatCommand } from './types';
import { log } from '../../utils/logging';

export class CommandParser {
  /**
   * Parses a natural language query to extract intent and command type
   */
  static parse(query: string): ChatCommand {
    const normalizedQuery = query.toLowerCase().trim();
    log(`Parsing command: "${query}"`);

    // Polish/improve commands
    if (this.matchesPolish(normalizedQuery)) {
      return {
        type: 'polish',
        intent: 'polish',
        parameters: {}
      };
    }

    // Rephrase commands
    if (this.matchesRephrase(normalizedQuery)) {
      return {
        type: 'rephrase',
        intent: 'rephrase',
        parameters: {}
      };
    }

    // Custom commands (like "make it mutual")
    const customCommand = this.parseCustomCommand(normalizedQuery);
    if (customCommand) {
      return customCommand;
    }

    // Unknown command - will be sent to AI for interpretation
    return {
      type: 'unknown',
      intent: normalizedQuery,
      parameters: {}
    };
  }

  private static matchesPolish(query: string): boolean {
    const polishKeywords = [
      'polish',
      'improve',
      'clean up',
      'fix grammar',
      'fix spelling',
      'make it better',
      'enhance'
    ];
    return polishKeywords.some(keyword => query.includes(keyword));
  }

  private static matchesRephrase(query: string): boolean {
    const rephraseKeywords = [
      'rephrase',
      'rewrite',
      'reword',
      'say differently',
      'express differently'
    ];
    return rephraseKeywords.some(keyword => query.includes(keyword));
  }

  private static parseCustomCommand(query: string): ChatCommand | null {
    // Check for "make it X" pattern
    const makeItMatch = query.match(/make it ([\w\s]+)/i);
    if (makeItMatch) {
      const target = makeItMatch[1].trim();
      return {
        type: 'custom',
        intent: `make it ${target}`,
        parameters: { target }
      };
    }

    // Check for "convert to X" pattern
    const convertMatch = query.match(/convert to ([\w\s]+)/i);
    if (convertMatch) {
      const target = convertMatch[1].trim();
      return {
        type: 'custom',
        intent: `convert to ${target}`,
        parameters: { target }
      };
    }

    // Check for "translate to X" pattern
    const translateMatch = query.match(/translate to ([\w\s]+)/i);
    if (translateMatch) {
      const language = translateMatch[1].trim();
      return {
        type: 'custom',
        intent: `translate to ${language}`,
        parameters: { language }
      };
    }

    return null;
  }
}

